import React from 'react';
import { useHistory } from 'react-router-dom';
import '../css/subscription.css';

const SubscriptionCancel = () => {
    const history = useHistory();

    return (
        <div className="subs container" style={{ textAlign: 'center', paddingTop: '50px' }}>
            <div style={{ fontSize: '60px', marginBottom: '20px' }}><span role="img" aria-label="sad face">😕</span></div>
            <h1 style={{ color: '#FF9800', marginBottom: '20px' }}>Paiement annulé</h1>
            <p style={{ fontSize: '18px', marginBottom: '30px' }}>
                Votre paiement a été annulé. Aucun montant n'a été débité.
            </p>
            <p style={{ color: '#666' }}>
                Si vous avez rencontré un problème, n'hésitez pas à nous contacter.
            </p>
            <div style={{ marginTop: '30px' }}>
                <button
                    className="btn blue rounded"
                    onClick={() => history.push('/dashboard')}
                    style={{ marginRight: '10px' }}
                >
                    Retour au tableau de bord
                </button>
                <button
                    className="btn green rounded"
                    onClick={() => history.goBack()}
                >
                    Réessayer
                </button>
            </div>
        </div>
    );
};

export default SubscriptionCancel;
